export default function badRequest(err) {
    return {
        type: "error",
        status: err.status || 500,
        error: {
            name: err.name,
            message: err.message,
        },
    };
}
//# sourceMappingURL=badRequest.util.js.map